import { render } from "./Navi.vue?vue&type=template&id=24ee9484&scoped=true"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"

import "./Navi.vue?vue&type=style&index=0&id=24ee9484&scoped=scoped&lang=css"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ee9484"]])

export default __exports__